<template>
  <div class="main-container">
    <div>
      <div class="link-container">
        <div class="quote-links">
          <div
            class="quote-link router-link-exact-active"
            >Unlimited Golf Search</div
          >
        </div>
      </div>
      <div class="content-container">
        <SearchBox />
        <InstantQuote />
      </div>
    </div>
  </div>
</template>

<script>
import SearchBox from "../components/SearchBox";
import InstantQuote from "./InstantQuote";
export default {
  name: "UnlimitedGolfSearchView",
  components: {
    InstantQuote,
    SearchBox,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap");

* {
  font-family: "Roboto", sans-serif;
}
button,
a {
  cursor: pointer;
  &:focus,
  &:active {
    outline: none !important;
  }
  text-decoration: none !important;
}

.main-container {
  width: 1700px;
  @media screen and (max-width: 1750px) {
    width: 100%;
  }
  margin: auto;
}
.link-container {
  border: 1px solid #cccccc;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 4px solid #5e4896;
  padding: 30px 40px 0;
  @media screen and (max-width: 500px) {
    padding: 15px 20px 0;
  }
  .quote-links {
    display: flex;
    flex-wrap: wrap;
    .quote-link {
      height: 70px;
      width: 288px;
      color: #5e4896;
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      &.router-link-exact-active {
        border: 1px solid #5e4896;
        border-bottom: 0;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        @media screen and (max-width: 500px) {
          border-bottom: 1px solid #5e4896;
        }
      }
      @media screen and (max-width: 1250px) {
        font-size: 18px;
      }
      @media screen and (max-width: 800px) {
        width: calc(50% - 10px);
      }
      @media screen and (max-width: 500px) {
        border-radius: 10px;
        width: 100%;
        border: 1px solid #ccc;
        margin: 10px;
      }
    }
  }
}
.content-container {
  border-top: 0;
  border: 1px solid #cccccc;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  @media screen and (max-width: 500px) {
    padding: 15px 5px;
  }
}
</style>
